import type { Schema } from '@cli-types/core-engine/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'

export function collectInvalidDefaultValueFromErrors(schema: Schema, errors: string[]): void {
  const flatFields = flattenFields(schema.fields || [])
  const fieldMap = new Map(flatFields.map((field) => [field.name, field]))

  for (const field of flatFields) {
    if (field.defaultValueFrom === undefined) continue
    if (typeof field.defaultValueFrom !== 'string' || field.defaultValueFrom.trim().length === 0) {
      errors.push(
        `Field "${field.name}" has invalid defaultValueFrom="${String(field.defaultValueFrom)}". Expected the name of another field in the same schema.`
      )
      continue
    }

    const sourceField = field.defaultValueFrom.trim()
    if (field.primaryKey || field.name === 'id') {
      errors.push(
        `Field "${field.name}" cannot use defaultValueFrom because generated ID and primary key fields are owned by BetterStart.`
      )
    } else if (sourceField === field.name) {
      errors.push(`Field "${field.name}" cannot use itself as defaultValueFrom.`)
    } else {
      const source = fieldMap.get(sourceField)
      if (!source) {
        errors.push(
          `Field "${field.name}" has defaultValueFrom="${sourceField}", but no field named "${sourceField}" exists in schema "${schema.name}".`
        )
      } else if (source.primaryKey || sourceField === 'id') {
        errors.push(
          `Field "${field.name}" has defaultValueFrom="${sourceField}", but generated ID and primary key fields cannot be used as defaultValueFrom sources.`
        )
      }
    }
  }
}
